module.exports = __webpack_public_path__ + "0b8ce6abffe8f9bba088f240bf9e1eec.jpg";